import animateTo from "./util/animateTo";
import {generateSection} from "./util/generateSection";
import takeSnapShot from "./util/takeSnapShot";


const initialSections = async ({
    product,
    sections,
    setSelectedSectionId
}) => {
    const sectionListData = sections;

    const sectionList = await Promise.all(sectionListData.map(section => generateSection(section, product)));
    sectionList.forEach(section => {
        window.threeViewer.scene.add(section)
    })
    
    sectionList.forEach(section => {
        section.update()
    })

    animateTo(sectionListData[0]?.sectionId, {
        fit: false,//!!snap.ui.zoom//!!selectedSectionId
        current: false,
        duration: 0,
        options: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0
        },
    })
    
    await new Promise(resolve => setTimeout(resolve, 150))

    for (let i = 0; i < sectionListData.length; i++) {
        const PreviewImage = await takeSnapShot(sectionListData[i], false)
        const thumbnail_image_url = URL.createObjectURL(PreviewImage);
        sectionListData[i]["thumbnail_image_url"] = thumbnail_image_url;
    }
    setSelectedSectionId(sectionListData[0].sectionId)

    return {
        loading: false,
    }
    
}

export default initialSections;